const Connector = require('./services/Connector');
const Configuration = require('./instances/Configuration');

module.exports = {
  Connector: Connector.default,
  Configuration: Configuration.default,
};
